// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/sliderimg/footerBanner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.container {
  padding: 50px 0px
}

.width100 {
  width: 100%;
}

.height100 {
  height: 100%;
}

body,
* {
  font-family: 'Poppins', sans-serif !important;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ---------------- button header--------- */

.w-h-66 {
  width: 66px;
  height: 66px;
}

.fontWeight600 {
  font-weight: 600 !important;
}

.header-btn {
  width: 244px;
  height: 44px;
  padding: 10px 15px 10px 15px !important;
  gap: 10px;
  border-radius: 10px !important;
  background: linear-gradient(90.67deg, #ED3237 3.01%, #F08F21 99.49%);
  color: #fff !important;
}

.banner-text {
  width: 575px;
  /* height: 192px; */
  font-size: 46px !important;
  font-weight: 400 !important;
}

.banner-text span {
  color: rgba(237, 50, 55, 1);
  font-weight: 700;
}

.font18 {
  font-size: 18px !important;
}

.font16 {
  font-size: 16px !important;
}

.font14 {
  font-size: 14px !important;
}

.banner-subtext {
  font-weight: 400 !important;
  line-height: 27px !important;
  text-align: left;
  color: rgba(0, 0, 0, 1);
  width: 90%;
}

.banner-bottom-text {
  height: 100%;
  border-radius: 10px;
  background: rgba(217, 217, 217, 1);
  position: relative;
  z-index: 2;
}

.circle {
  width: 108px;
  height: 108px;
  top: -30px;
  right: -35px;
  gap: 0px;
  border-radius: 100%;
  position: absolute;
  background: #D9D9D9;
  z-index: 1;
}

.box-ad-style {
  display: flex;
  align-items: center;
  gap: 30px;
  /* gap: 15px; */
}

.banner-bottom-text p {
  font-size: 16px;
  font-weight: 600;
  line-height: 27.2px;
  text-align: left;

}

.banner-bottom-text span {
  font-size: 36.3px;
  font-weight: 300;
}

.commonBg {
  background: #F6F5F5;
}

.ads-container {
  /* height: 485px; */
  /* padding: 50px 105px; */
  /* padding: 50px 80px; */
  display: flex;
  flex-direction: row;
  /* gap: 135px; */
}

.marginTop3 {
  margin-top: 3rem;
}

.marginTop5 {
  margin-top: 5rem;
}

.channel-container span {
  font-size: 14px;
  font-weight: 600;
  display: block;
}

.marquee-slider {
  outline: none !important;
  width: 190px !important;
  height: 200px !important;
  border-radius: 10px;
  background: #F6F5F5;
  margin: 0px 10px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.marquee-slider p {
  width: 100%;
  padding-left: 40px;
}

.portfolio-container p,
.solution-container p,
.ad-head-text p,
.review-container p {
  font-size: 32px;
  font-weight: 700;
}

.margin-b-t span {
  margin-bottom: 40px;
}

.margin-b-t p {
  margin-top: 60px;
}
.ad-head-text{
  margin-left: 10rem;
}
.portfolio-container span,
.solution-container span,
.solution-grid p,
.ad-head-text span,
.campaign-right-grid span,
.review-container span {
  font-size: 16px;
  font-weight: 500;
  display: block;
}

.portfolio img {
  width: 112px;
  height: 112px;
  border-radius: 100%;
  background-color: rgba(206, 206, 206, 1);
  object-fit: contain;
}

.support img {
  width: 100%;
  height: 579px;
  border-radius: unset;
  background: none;
}

.solution {
  padding: 50px 105px;
  /* padding: 50px 80px; */
}

.solution-grid {
  position: relative;
}

.solution-grid::after {
  left: 25%;
  width: 50%;
}

.stepper::after {
  left: 30px;
  width: 58px;
}

.solution-grid::after,
.stepper::after {
  content: '';
  position: absolute;
  bottom: -15px;
  transform: translateX(-50%);
  height: 2px;
  background-image: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);
}

.solution-grid span {
  font-size: 59.3px;
  font-weight: 300;
  line-height: 88.95px;
  letter-spacing: -0.04em;
  text-align: left;
}

.textgradient {
  background-image: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
}

.campaign-right-grid {
  font-size: 20px;
  font-weight: 500;
  text-align: left;
}

.campaign-right-grid span {
  line-height: 4;
}

.QontoStepIcon-circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: black;
}

.footer {
  padding: 16px 16px 0px;
}

.footer>.solution>p {
  font-size: 46px;
  font-weight: 600;
  line-height: 59.8px;
  letter-spacing: -0.03em;
  text-align: left;
  color: white;
  width: 70%;
}

.footer>div:first-child {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  left: 0px;
  background-repeat: no-repeat;
  background-size: 100%;
  border-radius: 40px;
}

.footer button {
  font-weight: 700;
  color: rgba(1, 2, 5, 1);
  width: 299px;
  height: 56px;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  justify-content: space-between;

}

.groov-footer {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 24px !important;
  text-align: left;
  padding-top: 1rem;
  width: 90%;
}

/* ------------ stepper----------- */
.stepper {
  position: relative;
  font-size: 20px !important;
}

.header-btn:disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  box-shadow: none;
  background: rgba(0, 0, 0, 0.12) !important;
}

.supportalign>p {
  height: 56px;
  padding: 10px 5px 12px 5px;
  border-radius: 10px;
  background: #D9D9D9;
  position: absolute;
  font-size: 14px;
  font-weight: 500;
}

.supportalign p:nth-child(1) {
  width: 200px;
  top: 12px;
  left: 320px;
}

.supportalign p:nth-child(2) {
  width: 159px;
  top: 12px;
  left: 640px;
}

.supportalign p:nth-child(3) {
  width: 174px;
  top: 181px;
  left: 192px;
}

.supportalign p:nth-child(4) {
  width: 212px;
  top: 181px;
  left: 810px;
}

.supportalign p:nth-child(5) {
  width: 192px;
  top: 341px;
  left: 174px;
}

.supportalign p:nth-child(6) {
  width: 199px;
  top: 341px;
  left: 823px;
}

.supportalign p:nth-child(7) {
  width: 191px;
  top: 512px;
  left: 345px;
}

.supportalign p:nth-child(8) {
  width: 133px;
  top: 512px;
  left: 640px;
}
.bg-banner-image{
  background: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);
  width: 415.16px;
  height: 484.82px;
  top: 234.18px;
  left: 892.84px;
  gap: 0px;
  border-radius: 250px 250px 10px 10px;
  opacity: 0px;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4CAA4C;;AAE5C;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,SAAS;EACT,8BAA8B;EAC9B,oEAAoE;EACpE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,0GAA0G;AAC5G;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0GAA0G;EAC1G,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,oEAAoE;EACpE,SAAS;EACT,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;;AAEhC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,oGAAoG;EACpG,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.container {\n  padding: 50px 0px\n}\n\n.width100 {\n  width: 100%;\n}\n\n.height100 {\n  height: 100%;\n}\n\nbody,\n* {\n  font-family: 'Poppins', sans-serif !important;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ---------------- button header--------- */\n\n.w-h-66 {\n  width: 66px;\n  height: 66px;\n}\n\n.fontWeight600 {\n  font-weight: 600 !important;\n}\n\n.header-btn {\n  width: 244px;\n  height: 44px;\n  padding: 10px 15px 10px 15px !important;\n  gap: 10px;\n  border-radius: 10px !important;\n  background: linear-gradient(90.67deg, #ED3237 3.01%, #F08F21 99.49%);\n  color: #fff !important;\n}\n\n.banner-text {\n  width: 575px;\n  /* height: 192px; */\n  font-size: 46px !important;\n  font-weight: 400 !important;\n}\n\n.banner-text span {\n  color: rgba(237, 50, 55, 1);\n  font-weight: 700;\n}\n\n.font18 {\n  font-size: 18px !important;\n}\n\n.font16 {\n  font-size: 16px !important;\n}\n\n.font14 {\n  font-size: 14px !important;\n}\n\n.banner-subtext {\n  font-weight: 400 !important;\n  line-height: 27px !important;\n  text-align: left;\n  color: rgba(0, 0, 0, 1);\n  width: 90%;\n}\n\n.banner-bottom-text {\n  height: 100%;\n  border-radius: 10px;\n  background: rgba(217, 217, 217, 1);\n  position: relative;\n  z-index: 2;\n}\n\n.circle {\n  width: 108px;\n  height: 108px;\n  top: -30px;\n  right: -35px;\n  gap: 0px;\n  border-radius: 100%;\n  position: absolute;\n  background: #D9D9D9;\n  z-index: 1;\n}\n\n.box-ad-style {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  /* gap: 15px; */\n}\n\n.banner-bottom-text p {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 27.2px;\n  text-align: left;\n\n}\n\n.banner-bottom-text span {\n  font-size: 36.3px;\n  font-weight: 300;\n}\n\n.commonBg {\n  background: #F6F5F5;\n}\n\n.ads-container {\n  /* height: 485px; */\n  /* padding: 50px 105px; */\n  /* padding: 50px 80px; */\n  display: flex;\n  flex-direction: row;\n  /* gap: 135px; */\n}\n\n.marginTop3 {\n  margin-top: 3rem;\n}\n\n.marginTop5 {\n  margin-top: 5rem;\n}\n\n.channel-container span {\n  font-size: 14px;\n  font-weight: 600;\n  display: block;\n}\n\n.marquee-slider {\n  outline: none !important;\n  width: 190px !important;\n  height: 200px !important;\n  border-radius: 10px;\n  background: #F6F5F5;\n  margin: 0px 10px;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.marquee-slider p {\n  width: 100%;\n  padding-left: 40px;\n}\n\n.portfolio-container p,\n.solution-container p,\n.ad-head-text p,\n.review-container p {\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.margin-b-t span {\n  margin-bottom: 40px;\n}\n\n.margin-b-t p {\n  margin-top: 60px;\n}\n.ad-head-text{\n  margin-left: 10rem;\n}\n.portfolio-container span,\n.solution-container span,\n.solution-grid p,\n.ad-head-text span,\n.campaign-right-grid span,\n.review-container span {\n  font-size: 16px;\n  font-weight: 500;\n  display: block;\n}\n\n.portfolio img {\n  width: 112px;\n  height: 112px;\n  border-radius: 100%;\n  background-color: rgba(206, 206, 206, 1);\n  object-fit: contain;\n}\n\n.support img {\n  width: 100%;\n  height: 579px;\n  border-radius: unset;\n  background: none;\n}\n\n.solution {\n  padding: 50px 105px;\n  /* padding: 50px 80px; */\n}\n\n.solution-grid {\n  position: relative;\n}\n\n.solution-grid::after {\n  left: 25%;\n  width: 50%;\n}\n\n.stepper::after {\n  left: 30px;\n  width: 58px;\n}\n\n.solution-grid::after,\n.stepper::after {\n  content: '';\n  position: absolute;\n  bottom: -15px;\n  transform: translateX(-50%);\n  height: 2px;\n  background-image: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);\n}\n\n.solution-grid span {\n  font-size: 59.3px;\n  font-weight: 300;\n  line-height: 88.95px;\n  letter-spacing: -0.04em;\n  text-align: left;\n}\n\n.textgradient {\n  background-image: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n.campaign-right-grid {\n  font-size: 20px;\n  font-weight: 500;\n  text-align: left;\n}\n\n.campaign-right-grid span {\n  line-height: 4;\n}\n\n.QontoStepIcon-circle {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: black;\n}\n\n.footer {\n  padding: 16px 16px 0px;\n}\n\n.footer>.solution>p {\n  font-size: 46px;\n  font-weight: 600;\n  line-height: 59.8px;\n  letter-spacing: -0.03em;\n  text-align: left;\n  color: white;\n  width: 70%;\n}\n\n.footer>div:first-child {\n  background-image: url('./img/sliderimg/footerBanner.png') !important;\n  left: 0px;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  border-radius: 40px;\n}\n\n.footer button {\n  font-weight: 700;\n  color: rgba(1, 2, 5, 1);\n  width: 299px;\n  height: 56px;\n  padding: 16px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 1);\n  justify-content: space-between;\n\n}\n\n.groov-footer {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 24px !important;\n  text-align: left;\n  padding-top: 1rem;\n  width: 90%;\n}\n\n/* ------------ stepper----------- */\n.stepper {\n  position: relative;\n  font-size: 20px !important;\n}\n\n.header-btn:disabled {\n  color: rgba(0, 0, 0, 0.26) !important;\n  box-shadow: none;\n  background: rgba(0, 0, 0, 0.12) !important;\n}\n\n.supportalign>p {\n  height: 56px;\n  padding: 10px 5px 12px 5px;\n  border-radius: 10px;\n  background: #D9D9D9;\n  position: absolute;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.supportalign p:nth-child(1) {\n  width: 200px;\n  top: 12px;\n  left: 320px;\n}\n\n.supportalign p:nth-child(2) {\n  width: 159px;\n  top: 12px;\n  left: 640px;\n}\n\n.supportalign p:nth-child(3) {\n  width: 174px;\n  top: 181px;\n  left: 192px;\n}\n\n.supportalign p:nth-child(4) {\n  width: 212px;\n  top: 181px;\n  left: 810px;\n}\n\n.supportalign p:nth-child(5) {\n  width: 192px;\n  top: 341px;\n  left: 174px;\n}\n\n.supportalign p:nth-child(6) {\n  width: 199px;\n  top: 341px;\n  left: 823px;\n}\n\n.supportalign p:nth-child(7) {\n  width: 191px;\n  top: 512px;\n  left: 345px;\n}\n\n.supportalign p:nth-child(8) {\n  width: 133px;\n  top: 512px;\n  left: 640px;\n}\n.bg-banner-image{\n  background: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);\n  width: 415.16px;\n  height: 484.82px;\n  top: 234.18px;\n  left: 892.84px;\n  gap: 0px;\n  border-radius: 250px 250px 10px 10px;\n  opacity: 0px;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
